
import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ServiceBase } from '@app/services/base.service';

@Injectable()
export class ProcessoGerarDocService extends ServiceBase {
  constructor(
    private http: HttpClient,
  ) {
    super();
  }

  adicionar(gerarDoc: FormData): Observable<any> {
    return this.http.post<any>(this.URL_API + `processoGerarDoc/`, gerarDoc, { headers: { meta: ['upload'] } })
      .pipe(
        catchError((error: any) => observableThrowError(error.json()))
      );
  }

  alterar(gerarDoc: FormData): Observable<any> {
    return this.http.put<any>(this.URL_API + 'processoGerarDoc', gerarDoc, { headers: { meta: ['upload'] } })
      .pipe(
        catchError((error: any) => observableThrowError(error.json()))
      );
  }

  deletar(id: number): Observable<any> {
    return this.http.delete<any>(this.URL_API + `processoGerarDoc/${id}`);
  }

  obterPorId(id: number): Observable<any> {
    return this.http.get<any>(this.URL_API + `processoGerarDoc/${id}`);
  }

  obterPorTags(id: number): Observable<any> {
    return this.http.get<any>(this.URL_API + `processoGerarDoc/obterTags`);
  }

  obterTodos(): Observable<any> {
    return this.http.get<any>(this.URL_API + 'processoGerarDoc/');
  }

  obterPesquisa(descricao: string, pagina: number): Observable<any> {
    descricao = encodeURIComponent(descricao);
    return this.http.get<any>(this.URL_API + `processoGerarDoc/pesquisar/?descricao=${descricao}&pagina=${pagina}`);
  }


  obterArquivo(id: number, sexo: string): Observable<any> {
    // let options = this.obterAutorizacao();
    // options.responseType = ResponseContentType.Blob;
    return this.http.get<any>(this.URL_API + `processoGerarDoc/ObterModelo/${id}/${sexo}`);
  }


  gerarDoc(processoId: number, id: number, sexo: string): Observable<any> {
    // let options = this.obterAutorizacao();
    // options.responseType = ResponseContentType.Blob;
    return this.http.get<any>(this.URL_API + `processoGerarDoc/GerarDoc/?processoId=${processoId}&id=${id}&sexo=${sexo}`);
  }

  gerarPeticao(processoId: number, id: number): Observable<any> {
    // let options = this.obterAutorizacao();
    // options.responseType = ResponseContentType.Blob;
    return this.http.get<any>(this.URL_API + `processoGerarDoc/GerarPeticao/?processoId=${processoId}&id=${id}`);
  }

  // obterTodos() {
  //   return this.http.get(this.URL_API + `ProcessoGerarDoc`)
  //     .map((res: Response) => res.json());
  // }

  // gerarDoc(processoId: number, id: number) {
  //   let options = this.obterAutorizacao();
  //   options.responseType = ResponseContentType.Blob;
  //   return this.http.get(this.URL_API + `ProcessoGerarDoc/GerarDoc/?processoId=${processoId}&id=${id}`, options)
  //     .map(res => {
  //       return new Blob([res.blob()])
  //     });
  // }
}
